import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(callback-with-footer)/cookies/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/GlobalStyles.tsx");
